module.exports = __webpack_public_path__ + "static/img/bgimg4-1.33815fe9.png";